<template>
  <PageView class="full-page" :no-sub-title-expected="true">
    <TitleView>{{ $t("login") }}</TitleView>

    <ContentView>
      <LoginView />
    </ContentView>
  </PageView>
</template>

<script lang="ts">
import { defineComponent } from "vue"
import LoginView from "@/views/login/LoginView.vue"
import TitleView from "@/views/commons/TitleView.vue"
import PageView from "@/views/commons/PageView.vue"
import ContentView from "@/views/commons/ContentView.vue"
import { LoginService } from "@/services/rest/login/LoginService"

export default defineComponent({
  name: "LoginPage",
  components: { LoginView, ContentView, TitleView, PageView },
  data() {
    return {
      loginService: LoginService.INSTANCE,
    }
  },
  mounted(): void {
    this.redirectIfAlreadyLogged()
  },
  methods: {
    async redirectIfAlreadyLogged(): Promise<void> {
      const loggedUser = await this.loginService.getLoggedUser()
      if (loggedUser && loggedUser.id) {
        await this.$router.push(this.loginService.getPageToRedirectToAfterLogin(loggedUser))
      }
    },
  },
})
</script>
